import { io } from "socket.io-client";

let socket = null;

export function getSocket() {
  if (socket && socket.connected) return socket;
  if (!socket) {
    const token = localStorage.getItem("token");
    if (!token) return null;
    socket = io({
      path: "/socket.io",
      // Read the token on every (re)connect, so a renewed or changed-password
      // token is used instead of the one captured when the socket was made.
      auth: (cb) => cb({ token: localStorage.getItem("token") }),
      transports: ["websocket", "polling"],
      reconnection: true,
      reconnectionDelay: 1000,
    });
    socket.on("connect_error", (err) => {
      console.warn("[socket] connect_error:", err.message);
    });
  } else if (!socket.connected) {
    socket.connect();
  }
  return socket;
}

export function disconnectSocket() {
  if (socket) {
    try { socket.disconnect(); } catch (e) {}
    socket = null;
  }
}
